import { Component } from 'react';
import { BlockInstanceProps } from '../Block';
import {
  ContentTypeEnum,
  ProfileEnum,
  fontColorEnum,
  BackgroundColorEnum,
} from '../../constants/cms-constants';
import Profile from '../../components/Profile';
import {
  ComponentWithControlOptions,
  ControlOption,
} from '../../utils/controlOptions/ControlOptionDecorator';
import controlOptionDefinitions from '../../utils/controlOptions/controlOptionDefinitions';

@ControlOption([
  {
    key: 'backgroundColor',
    definition: controlOptionDefinitions.backgroundColor,
  },
  {
    key: 'fontColor',
    definition: controlOptionDefinitions.fontColor,
  },
  {
    key: 'type',
    definition: controlOptionDefinitions.profileTypes,
  },
  {
    key: 'seoWeight',
    definition: controlOptionDefinitions.SEOWeightTypes,
  },
])
class ProfileBlock extends ComponentWithControlOptions<BlockInstanceProps> {
  static profileGridTypes = Profile.types;

  render() {
    const { block, blockContent } = this.props;
    const controlOptions = block?.controlOptionsV2;
    const backgroundColor =
      BackgroundColorEnum[controlOptions?.backgroundColor];
    const fontColor = fontColorEnum[controlOptions?.fontColor];
    const type = ProfileEnum[controlOptions?.type];
    const seoWeight = controlOptions?.seoWeight;

    let person;
    blockContent.doQuery((content) => {
      person = content.getFirstOfType(ContentTypeEnum.PERSON);
    });

    return (
      <Profile
        person={person}
        link={block?.link}
        backgroundColor={backgroundColor}
        fontColor={fontColor}
        type={type}
        header={block?.header?.main}
        bodyText={block?.bodyText}
        seoWeight={seoWeight}
      />
    );
  }
}

export default ProfileBlock;
